export const generateProvidesList =
  (
    listSelector: (result) => any[],
    idSelector: (element) => String | Number,
    type: String,
  ) =>
  (result): any => {
    if (!result) return [`${type}s`];
    const results = listSelector(result);
    return !!results
      ? [
          `${type}s`,
          ...results.map(item => ({
            type,
            id: idSelector(item),
          })),
        ]
      : [`${type}s`];
  };

export const generateProvides =
  <T>(
    idSelector: (result: T, error: any, args: any) => String | Number,
    type: String,
  ) =>
  (result: T, error: any, args: any): any[] =>
    !!result ? [{ type, id: idSelector(result, error, args) }] : [];

export const generateInvalidates =
  <T>(idSelector: (body: T) => string | number, type: string | string[]) =>
  (_result, _error, body: T): any => {
    const id = idSelector(body);

    if (Array.isArray(type)) {
      return type.flatMap(t => [`${t}s`, { type: t, id }]);
    } else {
      return [`${type}s`, { type, id }];
    }
  };
